import React, { useRef } from "react";
import { Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { assetsPath } from "../utils/assetsPath";
import { DateTimePicker } from "@mui/x-date-pickers";

const NewDateTimePicker = ({
  name,
  label,
  control,
  rules,
  errors,
  setValue,
  watch,
  minDate,
  maxDate,
  trigger, // <-- add trigger prop
}) => {
  const hasAutoSetTime = useRef(false); // Track if auto-set time has occurred

  return (
    <div>
      {label && <label className="labelName">{label}</label>}
      <div
        style={{
          width: "100%",
          marginBottom: "15px",
          marginTop: "10px",
          position: "relative",
        }}
      >
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field }) => (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                {...field}
                onChange={(date) => {
                  if (!date) {
                    setValue(name, "");
                    hasAutoSetTime.current = false;
                    if (trigger) trigger(name); // <-- trigger validation
                    return;
                  }

                  const selectedDate = dayjs(date);
                  const today = dayjs();

                  let finalDateTime = selectedDate;

                  // Only auto-set time if today is selected AND we haven't set it before
                  if (
                    selectedDate.isSame(today, "day") &&
                    !hasAutoSetTime.current
                  ) {
                    finalDateTime = selectedDate
                      .hour(today.hour())
                      .minute(today.minute());
                    hasAutoSetTime.current = true;
                  }

                  // Reset auto-set flag if user picks a non-today date
                  if (!selectedDate.isSame(today, "day")) {
                    hasAutoSetTime.current = false;
                  }

                  setValue(name, finalDateTime.format("DD/MM/YYYY HH:mm"));
                  if (trigger) trigger(name); // <-- trigger validation
                }}
                format="DD/MM/YYYY HH:mm"
                value={
                  field.value && field.value !== "Invalid Date"
                    ? dayjs(field.value, "DD/MM/YYYY HH:mm")
                    : null
                }
                minDateTime={minDate ? dayjs(minDate) : null}
                maxDateTime={maxDate ? dayjs(maxDate) : null}
                sx={{
                  width: "100%",
                  fontFamily: "inherit",
                }}
                slotProps={{
                  textField: {
                    variant: "standard",
                    InputProps: {
                      disableUnderline: true,
                      sx: {
                        fontSize: "15px",
                        border: "1px solid #cccccc",
                        backgroundColor: "#e8e8e8",
                        borderRadius: "8px",
                        paddingTop: "4px",
                        paddingBottom: "4px",
                        paddingLeft: "10px",
                        paddingRight: "12px",
                        color: "#000000",
                        opacity: 1,
                        "& .MuiInputBase-input::placeholder": {
                          color: "#808080",
                          opacity: 1,
                        },
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          )}
        />
        {watch(name) && watch(name) !== "Invalid Date" && (
          <img
            src={`${assetsPath.tick}`}
            alt="Tick Icon"
            className="tickIcon-datepicker"
          />
        )}
      </div>
      {errors && (
        <span className="errorField margin-bottom-15 margin-top-minus10">
          Required
        </span>
      )}
    </div>
  );
};

export default NewDateTimePicker;
